import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/admin/orders").then(r => setOrders(r.data)); }, []);
  return (
    <div data-testid="admin-orders-page">
      <h1 className="editorial-heading text-4xl">Ordini ({orders.length})</h1>
      <div className="mt-6 bg-card border border-border rounded-sm overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>ID</TableHead><TableHead>Data</TableHead><TableHead>Tipo</TableHead><TableHead>Articoli</TableHead><TableHead>Totale</TableHead><TableHead>Stato</TableHead><TableHead>Pagamento</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {orders.map(o => (
              <TableRow key={o.id} data-testid={`admin-order-${o.id}`}>
                <TableCell className="font-mono text-xs">{o.id.substring(0, 8)}</TableCell>
                <TableCell>{new Date(o.created_at).toLocaleDateString()}</TableCell>
                <TableCell><span className="chip bg-[hsl(var(--muted))]">{o.order_type}</span></TableCell>
                <TableCell>{o.items.length}</TableCell>
                <TableCell className="font-bold">€{o.total.toFixed(2)}</TableCell>
                <TableCell><span className="chip bg-[hsl(var(--muted))]">{o.status}</span></TableCell>
                <TableCell><span className={`chip ${o.payment_status === "paid" ? "bg-[hsl(var(--secondary))] text-white" : "bg-[hsl(var(--muted))]"}`}>{o.payment_status}</span></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
